import React, { useState, useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip, Paper, Box } from '@mui/material';
import { useMap, useMapEvents } from 'react-leaflet';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../store/reducers/helpersReducer';
import L from 'leaflet';





const SearchControlButton = () => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false)
    const buttonRef = useRef(null);
    const buttonPosition = useMemo(() => {
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        console.log(buttonRect)
        return buttonRect ? {
            top: buttonRect.top,
            left: buttonRect.left,
            right: buttonRect.right,
            bottom: buttonRect.bottom,
            width: buttonRect.width,
            height: buttonRect.height
        } : null;
    }, [buttonRef.current]);

    useMapEvents({
        'modal:open': (e) => {
            if (e.modalType !== 'search') {
                setIsOpen(false)
            }
        },
        'modal:close': () => {
            setIsOpen(false)
        }
    })

    const handleOpenToggle = (newState) => {
        setIsOpen(newState)
        if (newState) {
            dispatch(setModal({ modalType: 'search', modalProps: { buttonPosition } }))
        } else {
            dispatch(setModal(null))
        }
    }

    useEffect(() => {
        if (buttonRef.current) {
            L.DomEvent.disableClickPropagation(buttonRef.current)
            L.DomEvent.disableScrollPropagation(buttonRef.current)
        }
    }, [buttonRef.current]) 


    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 0, pointerEvents: 'auto', width: 'fit-content' }}>
            <Tooltip title="Поиск" placement="right-start" arrow>
                <Paper
                    ref={buttonRef}
                    elevation={3}
                    sx={{
                        display: 'flex',
                        order: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: window.innerWidth < 768 ? 26 : 34,
                        height: window.innerWidth < 768 ? 26 : 34,
                        // m: '10px 10px 5px 5px',
                        opacity: 0.9,
                        bgcolor: 'rgb(40, 40, 40)',
                        boxShadow: isOpen ? '0 0 3px 3px rgb(0, 174, 255)' : '0px 2px 6px grey',
                        color: 'white',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        '&:hover': {
                            bgcolor: 'rgb(50, 50, 50)',
                            transform: 'scale(1.1)',
                            
                        },
                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                    }}
                        onClick={() => handleOpenToggle(!isOpen)}
                >
                    <SearchIcon sx={{ fontSize: window.innerWidth < 768 ? 19 : 24 }} />
                </Paper>
            </Tooltip>
        </Box>

        , document.getElementById("map-controls-left-top-second-row")
    )




};

export default SearchControlButton; 